import React from "react";
import {CascadeItemContainer, CascadeMessage} from "../../styles/styles";
import ActionCard from "../ActionCard";


const ActionsCascadeList = ({actions, fromProject}) => {

    return(
        <CascadeItemContainer>
            {
                actions.length > 0 ?
                    (actions.map((a) => {
                        return <ActionCard
                            key={a.id}
                            actionId={a.id}
                            pilot={a.pilot}
                            name={a.name}
                            criticality={a.criticality}
                            deadline={a.deadline}
                            advancement={a.advancement}
                            tags={a.tags}
                            completedDate={a.firstTimeCompleted}
                            creationDate={a.creationDate}
                            projectId={a.projectId}
                            inActionPage={false}
                            fromOkrs={true}
                            fromProject={fromProject}
                        />
                    })) :
                    <CascadeMessage> Il n'y a pas encore d'actions pour {fromProject ? "ce projet" : "ce résultat clé"} </CascadeMessage>
            }
        </CascadeItemContainer>
    )
}

export default ActionsCascadeList